module.exports = __webpack_public_path__ + "static/img/loginbg2.74aefe16.png";